(function () {
  class FanVoteLeaderboard extends HTMLElement {
    connectedCallback() {
      this.rowsContainer = this.querySelector('[data-fvl-rows]');
      this.rows = Array.from(this.querySelectorAll('[data-fvl-row]'));
      if (!this.rowsContainer || !this.rows.length) return;

      // 统计接口：优先后台配置的 server_url，否则自动拼接 api.torraslife.com
      var base = window.TORRAS_API_BASE || 'https://api.torraslife.com';
      this.serverUrl = this.dataset.serverUrl || (base + '/api/team-vote/results');

      // 站点：优先后台配置，否则用全局 TORRAS_SITE，默认 us
      this.site = (this.dataset.site || window.TORRAS_SITE || 'us').trim() || 'us';
      this.sortByVotes = this.dataset.sort !== 'false';

      this.fetchResults();
    }

    fetchResults() {
      var self = this;
      var url = this.serverUrl + (this.serverUrl.indexOf('?') === -1 ? '?' : '&') + 'site=' + encodeURIComponent(this.site);

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Server responded with ' + response.status);
          return response.json();
        })
        .then(function (data) {
          if (!data || data.success === false) throw new Error('Invalid response');
          self.render(data);
        })
        .catch(function (error) {
          console.error('FanVoteLeaderboard: failed to load results', error);
        });
    }

    render(data) {
      var counts = Array.isArray(data.counts) ? data.counts : [];
      var total = typeof data.total === 'number' ? data.total : 0;

      // team_label -> votes 映射（忽略大小写/首尾空格，匹配更稳健）
      var voteMap = {};
      counts.forEach(function (item) {
        if (!item || item.team_label == null) return;
        var key = String(item.team_label).trim().toLowerCase();
        voteMap[key] = (voteMap[key] || 0) + (parseInt(item.votes, 10) || 0);
      });

      var rowData = this.rows.map(function (row) {
        var label = (row.dataset.teamLabel || '').trim().toLowerCase();
        var votes = voteMap[label] || 0;
        var pct = total > 0 ? Math.round((votes / total) * 100) : 0;
        return { row: row, votes: votes, pct: pct };
      });

      // 按票数从高到低重新排序 DOM（排行榜）
      if (this.sortByVotes) {
        var sorted = rowData.slice().sort(function (a, b) { return b.votes - a.votes; });
        var frag = document.createDocumentFragment();
        sorted.forEach(function (entry) { frag.appendChild(entry.row); });
        this.rowsContainer.appendChild(frag);
      }

      // 下一帧应用宽度，确保 transition 生效
      var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
      raf(function () {
        rowData.forEach(function (entry) {
          var fill = entry.row.querySelector('[data-fvl-fill]');
          var percent = entry.row.querySelector('[data-fvl-percent]');
          entry.row.style.setProperty('--fvl-pct', String(entry.pct));
          if (fill) fill.style.width = entry.pct + '%';
          if (percent) percent.textContent = entry.pct + '%';
        });
      });
    }
  }

  if (!customElements.get('fan-vote-leaderboard')) {
    customElements.define('fan-vote-leaderboard', FanVoteLeaderboard);
  }
})();
